import React from "react";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../../core/et3-page-div";
import Et3PageTitle from "../../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../../stores/core/core-history-store";
import Form from "./form";
import getKhattabatMatchingStore from "../../../../stores/khattabat-stores/matching-store";
import OneOOneMConversations from "./101m-conversations";
import AiMessages from "../../khattabat-clients/ai-messages";

const KhattabatResults = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "KHATTABAT_MATCHING_RESULTS",
      "KHATTABAT_MATCHING_RESULTS"
    );
    getKhattabatMatchingStore().getPaidUsersInformation();
  });

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{ position: "relative" }}
    >
      <Et3PageTitle
        title={i18n.get("KHATTABAT_MATCHING_RESULTS")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Form />
      <OneOOneMConversations />
      <AiMessages pageType={"matchResultPage"} />
    </ET3PageDiv>
  );
});
export default KhattabatResults;
